import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import useBasketExtras from "../hooks/useBasketExtras";
import useBasketManager from "../hooks/useBasketManager";
import { HiOutlineReceiptPercent } from "react-icons/hi2";
import EAButton from "../../shared/Buttons/EAButton";
import { BiInfoCircle } from "react-icons/bi";
import EATooltip from "../../shared/EATooltip/EATooltip";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  handleGetBasket: Function;
}

const BasketExtras: React.FC<IProps> = ({ handleGetBasket }) => {
  const { t } = useTranslation();
  const { extras, loading } = useBasketExtras();
  const { handleAddBasketLimited } = useBasketManager();
  const isPhoneLayout = useMediaQuery("(max-width: 660px)");
  const [addError, setAddError] = useState("");

  if (loading) return <EASkeletonLoader height="120px" />;

  if (!extras || extras.length === 0) {
    return null;
  }

  const handleAdd = async (extra: any) => {
    setAddError("");
    const result = await handleAddBasketLimited(extra, 1);
    if (!result?.ok) {
      setAddError(result?.error ?? "");
      return;
    }
    handleGetBasket();
  };

  return (
    <div className="basket-extras">
      <div className="basket-extras__header">
        <h5 className="basket-extras__title">{t("dodatki_do_zamowienia")}</h5>
      </div>
      <div className="basket-extras__list">
        {extras.map((extra: any) => {
          const isDiscount = Number(extra.price) !== Number(extra.listPrice ?? extra.price);
          return (
            <div key={extra.objectId} className="basket-extras__item">
              <div className="basket-extras__top">
                <div className="basket-extras__icon">
                  <HiOutlineReceiptPercent className="basket-extras__icon-svg" />
                </div>
                <div className="basket-extras__info">
                  <div className="basket-extras__title-row">
                    <b className="basket-extras__name">{extra.displayWebName || extra.name}</b>
                    <EATooltip
                      position="left"
                      content={<article dangerouslySetInnerHTML={{ __html: extra.description }} />}
                    >
                      <span
                        className="basket-extras__info-trigger"
                        tabIndex={0}
                        role="button"
                        aria-label={t("informacje")}
                      >
                        <BiInfoCircle className="basket-extras__info-icon" aria-hidden />
                      </span>
                    </EATooltip>
                  </div>
                </div>
                <div className="basket-extras__prices">
                  <div className="price-container basket-extras__price-container">
                    <b className={`price ${isDiscount ? "price-through" : ""}`}>
                      {Number(extra.listPrice ?? extra.price).toFixed(2)} {t("zl")}
                    </b>
                    {isDiscount && (
                      <b className={`price ${isDiscount ? "price-through-color" : ""}`}>
                        {Number(extra.price).toFixed(2)} {t("zl")}
                      </b>
                    )}
                  </div>
                </div>
              </div>
              <div className="basket-extras__actions">
                <EAButton title={t("dodaj")} onClick={() => handleAdd(extra)} compact={isPhoneLayout} />
              </div>
            </div>
          );
        })}
      </div>
      {addError && <EAAlert type="error" message={addError} compact />}
    </div>
  );
};

export default BasketExtras;


